import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';

/*
  This appScrollEnd directive emits an event
  when the user has scrolled to the end of a scrollable element or if the element is not scrollable.
  It listens to the scroll and window:resize events to determine the scroll position and emits a scrollEnd event accordingly. 
  The offset input can be used to adjust the scroll end threshold.
*/
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appScrollEnd]',
  standalone: true
})
export class ScrollEndDirective implements AfterViewInit {
  private el = inject(ElementRef);

  @Output() scrollEnd = new EventEmitter<boolean>();
  @Input() offset = 100;

  public ngAfterViewInit(): void {
    this.checkScrollEnd();
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event): void {
    this.checkScrollEnd();
  }

  private checkScrollEnd(): void {
    setTimeout(() => {
      const element = this.el.nativeElement;
      const isScrollable = this.isScrollable(element);

      if (!isScrollable) {
        this.scrollEnd.emit(true);
        return;
      }

      const isAtEnd = this.isAtEndOfScroll(element);
      this.scrollEnd.emit(isAtEnd);
    }, 300);
  }

  private isScrollable(element: HTMLElement): boolean {
    return element.scrollWidth > element.offsetWidth;
  }

  private isAtEndOfScroll(element: HTMLElement): boolean {
    return element.scrollLeft + element.offsetWidth >= element.scrollWidth - this.offset;
  }
}
